import { useEffect, useState } from "react";
import { Box, Button, Flex, Text } from "rebass/styled-components";
import Modal from "styled-react-modal";
import Select, { ActionMeta, components } from "react-select";
import { IThumbnailAipRecipeOutput } from "../../../../graphql/types/queries/recipes";
import Recipes from "./Recipes";
import ViewRecipe from "./ViewRecipe";
import { RbCircledChecked, RbCircledUnchecked } from "../../../../components/RadioButton";
import { ReactSelectStyles } from "../../../../styles/ReactSelectStyles";
import Articles from "./Articles";
import { IArticle } from "../../../../graphql/types/queries/articles";
import ViewArticle from "./ViewArticle";
import SpeakerSeries from "./SpeakerSeries";
import { ISpeakerSerie } from "../../../../graphql/types/queries/speakerSeries";
import { IThyroidGuide } from "../../../../graphql/types/queries/thyroidGuides";
import ThyroidGuides from "./ThyroidGuides";
import styled from "styled-components";

const Wrap = styled(Flex)`
  border-radius: 20px;

  @media screen and (max-width: 68.8125em) {
    border-radius: 0;
  }
`

interface ILinksToAdd {
}
enum EOptionsResourcesValues {
  'Recipes',
  'Articles',
  'SpeakerSeries',
  'ThyroidGuides',
}
interface IOptionsResources {
  value: EOptionsResourcesValues
  label: string;
}
const optionsResources: Array<IOptionsResources> = [
  { value: EOptionsResourcesValues.ThyroidGuides, label: 'Thyroid Guides' },
  { value: EOptionsResourcesValues.Recipes, label: 'Recipes' },
  { value: EOptionsResourcesValues.Articles, label: 'Articles' },
  { value: EOptionsResourcesValues.SpeakerSeries, label: 'Speaker Series' },
]

const Option = (props: any) => {
  return (
    <components.Option {...props}>
      <Flex alignItems={'center'}>
        {props.isSelected ? (
          <RbCircledChecked />
        ) : <RbCircledUnchecked />}

        <Text ml={2}>{props.children}</Text>
      </Flex>
    </components.Option>
  );
};

const SelectedResourceItem = ({ text, onRemove }: { text: string, onRemove: () => void }) => {
  return (
    <Flex mt={2}>
      <Flex alignItems={'center'} padding={'4px'} flex={1} style={{ borderRadius: '8px 0 0 8px', border: '1px solid #344F7A' }}>
        <Text fontWeight={300} fontSize='14px' ml={1}>{text}</Text>
      </Flex>
      <Flex alignItems={'center'} padding={'4px 8px'} onClick={onRemove} style={{ cursor: 'pointer', borderRadius: '0 8px 8px 0', border: '1px solid #344F7A', borderLeftWidth: 0, background: '#ebebeb' }}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.59 7L12 10.59L8.41 7L7 8.41L10.59 12L7 15.59L8.41 17L12 13.41L15.59 17L17 15.59L13.41 12L17 8.41L15.59 7Z" fill="#344F7A" />
        </svg>

      </Flex>
    </Flex>
  )
}

const RightColumnContainer = styled(Flex)`
  border: 1px solid #d6dde3; 
  background: white; 
  border-radius: 0 10px 10px 0; 
  border-left-width: 0;
  overflow-y: auto;
  @media screen and (max-width: 68.8125em) {
    border: 0px solid #d6dde3;
    background: transparent;
  }
`

const AddResourceModal = ({ okPressed, onCancel, setIsShowingChildModal }: { okPressed: (links: Array<{ text: string, link: string, type: string }>) => void, onCancel: () => void, setIsShowingChildModal: (isShowing: boolean) => void }) => {
  const [selectedResourceType, setSelectedResourceType] = useState<IOptionsResources>(optionsResources[0])
  const [selectedRecipes, setSelectedRecipes] = useState<Array<IThumbnailAipRecipeOutput>>([]);
  const [selectedArticles, setSelectedArticles] = useState<Array<IArticle>>([]);
  const [selectedSpeakerSeries, setSelectedSpeakerSeries] = useState<Array<ISpeakerSerie>>([]);
  const [selectedThyroidGuides, setSelectedThyroidGuides] = useState<Array<IThyroidGuide>>([]);
  const [viewRecipe, setViewRecipe] = useState<IThumbnailAipRecipeOutput | null>()
  const [viewArticle, setViewArticle] = useState<IArticle | null>()

  useEffect(() => {
    if (!!viewRecipe) {
      setIsShowingChildModal(true)
    } else {
      setIsShowingChildModal(false)
    }
  }, [viewRecipe])

  const toggleRecipeSelection = (recipe: IThumbnailAipRecipeOutput) => {
    if (selectedRecipes.findIndex(x => x.id === recipe.id) > -1) {
      setSelectedRecipes(selectedRecipes.filter(x => x.id !== recipe.id))
    } else {
      setSelectedRecipes([...selectedRecipes, recipe])
    }
  }

  const toggleArticleSelection = (article: IArticle) => {
    if (selectedArticles.findIndex(x => x.id === article.id) > -1) {
      setSelectedArticles(selectedArticles.filter(x => x.id !== article.id))
    } else {
      setSelectedArticles([...selectedArticles, article])
    }
  }

  const toggleSpeakerSerieSelection = (speakerSerie: ISpeakerSerie) => {
    if (selectedSpeakerSeries.findIndex(x => x.id === speakerSerie.id) > -1) {
      setSelectedSpeakerSeries(selectedSpeakerSeries.filter(x => x.id !== speakerSerie.id))
    } else {
      setSelectedSpeakerSeries([...selectedSpeakerSeries, speakerSerie])
    }
  }

  const toggleThyroidGuideSelection = (thyroidGuide: IThyroidGuide) => {
    if (selectedThyroidGuides.findIndex(x => x.id === thyroidGuide.id) > -1) {
      setSelectedThyroidGuides(selectedThyroidGuides.filter(x => x.id !== thyroidGuide.id))
    } else {
      setSelectedThyroidGuides([...selectedThyroidGuides, thyroidGuide])
    }
  }

  return (
    <Wrap
      flexDirection={'column'}
      paddingX={[0, 4, 4]}
      paddingY={4}
      height={['calc(100% - 70px)', '100%', '100%']}
      maxHeight={['calc(100% - 70px)', '100%', '100%']}
      alignSelf={['flex-start', 'auto', 'auto']}
      style={{
        background: '#f1f3f5',
        width: '100%',
        zIndex: 1001
      }}>
      <Flex alignItems={'center'} mb={3} flexDirection={['column', 'row', 'row']}>
        <Text mr={[0, 4, 4]} mb={[2, 0, 0]} fontSize='18px' fontWeight={500}>Attach Resources</Text>
        <Select
          isSearchable={false}
          styles={ReactSelectStyles.initialStyles}
          options={optionsResources}
          value={selectedResourceType}
          onChange={(option: IOptionsResources | null, actionMeta: ActionMeta<IOptionsResources>) => {
            if (!option) return
            setSelectedResourceType(option)
          }}
          components={{ Option }} />
      </Flex>
      <Box style={{ width: '100%', height: '1px', backgroundColor: '#d5dce1' }} />

      <Flex mt={[0, 3, 3]} flexDirection={'row'} flex={1} style={{ overflow: 'hidden' }}>
        <Flex display={['none !important', 'flex !important', 'flex !important']} p={2} flexDirection={'column'} style={{ border: '1px solid #d6dde3', minWidth: '300px', maxWidth: '300px', background: '#f9fafa', borderRadius: '10px 0 0 10px', overflowY: 'auto' }}>
          <Text fontWeight={600}>To Attach:</Text>
          <Text fontWeight={500} ml={1} mt={2} style={{ cursor: 'pointer' }} onClick={() => setSelectedResourceType(optionsResources.find(x => x.value === EOptionsResourcesValues.Recipes)!)}>Recipes</Text>
          {selectedRecipes.length < 1 && (
            <Text ml={2} fontWeight={300} fontSize='14px' color={'grey'} style={{ cursor: 'pointer' }} onClick={() => setSelectedResourceType(optionsResources.find(x => x.value === EOptionsResourcesValues.Recipes)!)}>no recipe selected</Text>
          )}
          {selectedRecipes.length > 0 && selectedRecipes.map(r => {
            return <SelectedResourceItem key={`selectedRec${r.id}`} text={r.name} onRemove={() => {
              if (selectedRecipes.findIndex(x => x.id === r.id) > -1) {
                setSelectedRecipes(selectedRecipes.filter(x => x.id !== r.id))
              }
            }} />
          })}
          <Text fontWeight={500} ml={1} mt={3} style={{ cursor: 'pointer' }} onClick={() => setSelectedResourceType(optionsResources.find(x => x.value === EOptionsResourcesValues.Articles)!)}>Articles</Text>
          {selectedArticles.length < 1 && (
            <Text ml={2} fontWeight={300} fontSize='14px' color={'grey'} style={{ cursor: 'pointer' }} onClick={() => setSelectedResourceType(optionsResources.find(x => x.value === EOptionsResourcesValues.Articles)!)}>no article selected</Text>
          )}
          {selectedArticles.length > 0 && selectedArticles.map(r => {
            return <SelectedResourceItem key={`selectedArt${r.id}`} text={r.title || ''} onRemove={() => {
              if (selectedArticles.findIndex(x => x.id === r.id) > -1) {
                setSelectedArticles(selectedArticles.filter(x => x.id !== r.id))
              }
            }} />
          })}
          <Text fontWeight={500} ml={1} mt={3} style={{ cursor: 'pointer' }} onClick={() => setSelectedResourceType(optionsResources.find(x => x.value === EOptionsResourcesValues.SpeakerSeries)!)}>Speaker Series</Text>
          {selectedSpeakerSeries.length < 1 && (
            <Text ml={2} fontWeight={300} fontSize='14px' color={'grey'} style={{ cursor: 'pointer' }} onClick={() => setSelectedResourceType(optionsResources.find(x => x.value === EOptionsResourcesValues.SpeakerSeries)!)}>no speaker serie selected</Text>
          )}
          {selectedSpeakerSeries.length > 0 && selectedSpeakerSeries.map(r => {
            return <SelectedResourceItem key={`selectedArt${r.id}`} text={r.name || ''} onRemove={() => {
              if (selectedSpeakerSeries.findIndex(x => x.id === r.id) > -1) {
                setSelectedSpeakerSeries(selectedSpeakerSeries.filter(x => x.id !== r.id))
              }
            }} />
          })}
          <Text fontWeight={500} ml={1} mt={3} style={{ cursor: 'pointer' }} onClick={() => setSelectedResourceType(optionsResources.find(x => x.value === EOptionsResourcesValues.ThyroidGuides)!)}>Thyroid Guides</Text>
          {selectedThyroidGuides.length < 1 && (
            <Text ml={2} fontWeight={300} fontSize='14px' color={'grey'} style={{ cursor: 'pointer' }} onClick={() => setSelectedResourceType(optionsResources.find(x => x.value === EOptionsResourcesValues.ThyroidGuides)!)}>no thyroid guide selected</Text>
          )}
          {selectedThyroidGuides.length > 0 && selectedThyroidGuides.map(r => {
            return <SelectedResourceItem key={`selectedThyroidGuide${r.id}`} text={r.name || ''} onRemove={() => {
              if (selectedThyroidGuides.findIndex(x => x.id === r.id) > -1) {
                setSelectedThyroidGuides(selectedThyroidGuides.filter(x => x.id !== r.id))
              }
            }} />
          })}
        </Flex>
        <RightColumnContainer
          flexDirection={'column'} flex={1}>
          {selectedResourceType.value === EOptionsResourcesValues.Recipes && (
            <Recipes
              viewRecipe={(recipe: IThumbnailAipRecipeOutput) => setViewRecipe(recipe)}
              selectedRecipes={selectedRecipes}
              setSelectedRecipes={(recipe) => {
                toggleRecipeSelection(recipe)
              }} />
          )}
          {selectedResourceType.value === EOptionsResourcesValues.Articles && (
            <Articles
              viewArticle={(article) => setViewArticle(article)}
              selectedArticles={selectedArticles}
              setSelectedArticles={(article) => {
                toggleArticleSelection(article)
              }}
            />
          )}
          {selectedResourceType.value === EOptionsResourcesValues.SpeakerSeries && (
            <SpeakerSeries
              selectedSpeakerSeries={selectedSpeakerSeries}
              setSelectedSpeakerSeries={(speakerSerie) => {
                toggleSpeakerSerieSelection(speakerSerie)
              }}
            />
          )}
          {selectedResourceType.value === EOptionsResourcesValues.ThyroidGuides && (
            <ThyroidGuides
              selectedSpeakerSeries={selectedThyroidGuides}
              setSelectedSpeakerSeries={(speakerSerie) => {
                toggleThyroidGuideSelection(speakerSerie)
              }}
            />
          )}
        </RightColumnContainer>
      </Flex>
      <Flex mt={3} flexDirection='row' alignItems={'center'} justifyContent='center' style={{ width: '100%' }}>
        <Button
          variant={'primary'}
          mr={3}
          style={{ borderRadius: '8px' }}
          disabled={!(selectedRecipes.length > 0 || selectedArticles.length > 0 || selectedSpeakerSeries.length > 0 || selectedThyroidGuides.length > 0)}
          onClick={() => {
            let res: Array<{ text: string, link: string, type: string }> = []
            selectedRecipes.map(x => res.push({
              text: x.name,
              link: `https://app.palomahealth.com/recipes/${encodeURI(x.name)}`,
              type: 'recipe'
            }))
            selectedArticles.filter(x => !!x.title).map(x => {
              if (x.title) {
                res.push({
                  text: x.title,
                  link: `https://app.palomahealth.com/articles/${encodeURI(x.title)}`,
                  type: 'article'
                })
              }
            })
            selectedSpeakerSeries.filter(x => !!x.videoLink).map(x => {
              if (x.videoLink) {
                res.push({
                  text: x.name,
                  link: x.videoLink,
                  type: 'speaker series'
                })
              }
            })
            selectedThyroidGuides.filter(x => !!x.guidePdfLink).map(x => {
              if (x.guidePdfLink)
                res.push({
                  text: x.name,
                  link: x.guidePdfLink,
                  type: 'thyroid guide'
                })
            })
            okPressed(res)
          }}>{`Insert ${selectedRecipes.length > 0 || selectedArticles.length > 0 || selectedSpeakerSeries.length > 0 || selectedThyroidGuides.length > 0 ? `(${selectedRecipes.length + selectedArticles.length + selectedSpeakerSeries.length + selectedThyroidGuides.length} resources)` : ''}`}</Button>
        <Button variant={'white'} ml={3} onClick={() => onCancel()}>Cancel</Button>
      </Flex>
      {!!viewRecipe && (
        <Modal
          isOpen={!!viewRecipe}
          onBackgroundClick={(e) => setViewRecipe(null)}
          onEscapeKeydown={(e) => {
            console.log('STOP')
            e.preventDefault()
            e.stopImmediatePropagation()
            e.stopPropagation()
            setViewRecipe(null)
          }}>
          <Flex flexDirection={'column'}
            height={['calc(100% - 70px)', '90%', '90%']}
            maxHeight={['calc(100% - 70px)', '90%', '90%']}
            alignSelf={['flex-start', 'auto', 'auto']}
            style={{
              background: '#f1f3f5',
              borderRadius: '20px',
              zIndex: 1005,
              overflow: 'hidden'
            }}>
            <ViewRecipe thumbnail={viewRecipe} selectedRecipes={selectedRecipes} onSelect={() => {
              toggleRecipeSelection(viewRecipe)
              setViewRecipe(null)
            }} onCancel={() => setViewRecipe(null)} />
          </Flex>
        </Modal>
      )}
      {!!viewArticle && (
        <Modal
          isOpen={!!viewArticle}
          onBackgroundClick={(e) => setViewArticle(null)}
          onEscapeKeydown={(e) => {
            console.log('STOP')
            e.preventDefault()
            e.stopImmediatePropagation()
            e.stopPropagation()
            setViewArticle(null)
          }}>
          <Flex flexDirection={'column'}
            height={['calc(100% - 70px)', '90%', '90%']}
            maxHeight={['calc(100% - 70px)', '90%', '90%']}
            alignSelf={['flex-start', 'auto', 'auto']}
            style={{
              background: '#f1f3f5',
              borderRadius: '20px',
              zIndex: 1005,
              overflow: 'hidden'
            }}>
            <ViewArticle
              article={viewArticle}
              selectedArticles={selectedArticles}
              onSelect={(article?: IArticle) => {
                toggleArticleSelection(article || viewArticle)
                setViewArticle(null)
              }}
              viewRelatedPost={article => setViewArticle(article)}
              onCancel={() => setViewArticle(null)}
            />
          </Flex>
        </Modal>
      )}
    </Wrap>
  )
}

export default AddResourceModal